<!-- Section 1: Hero -->
<div class="container-fluid whatsapp-api-section py-5">
  <div class="row align-items-center">
    <!-- Left Content -->
    <div class="col-lg-6 mb-4 mb-lg-0">
      <div class="content">
        <div class="title-line"></div>
        <h1>Verify Emails. Protect Your Reputation.</h1>
        <p>
          Stop wasting time and money on invalid addresses. MALtech’s email
          verification ensures accuracy, deliverability, and trust—at scale.
        </p>

        <!-- CTA Buttons -->
        <div class="mt-4 d-flex flex-wrap gap-3">
          <button class="btn btn-outline-primary" (click)="scrollToPlans()">
            Explore Plans
          </button>
          <a routerLink="/signup" href="/signup" class="btn btn-primary" aria-label="Sign Up"  [attr.href]="'/signup'"
            >Sign Up</a
          >
        </div>
      </div>
    </div>

    <!-- Right Image -->
    <div class="col-lg-6 text-center">
      <img
        src="assets/images/1st.jpeg"
        width="500"
        alt="WhatsApp Business API"
        class="img-fluid illustration"
        loading="lazy"
      />
    </div>
  </div>
</div>

<!-- Section 2: Get Verified Email List -->
<!-- Section 2: Get Verified Email List -->
<section class="ev-verified-list py-5">
  <div class="container">
    <h2 class="section-heading text-center mb-4">Get Verified Email List</h2>

    <div class="row align-items-center">
      <!-- Image Column -->
      <div class="col-md-6 mb-4 mb-md-0 text-center">
        <img
          src="assets/images/2nd.jpeg"
          alt="Get Verified Email Illustration"
          class="img-fluid rounded"
          loading="lazy"
        />
      </div>

      <!-- Description Column -->
      <div class="col-md-6">
        <p>
          Verifying valid email IDs that belong to real people is called Email
          Verification. It ensures your emails land in the inbox instead of the
          spam folder...
        </p>
        <ul class="list-unstyled ev-checklist">
          <li class="mb-2">
            <i class="bi bi-check-circle-fill text-success me-2"></i>
            Identification of disabled and inactive email accounts
          </li>
          <li class="mb-2">
            <i class="bi bi-check-circle-fill text-success me-2"></i> Detection
            and removal of spam traps quickly and accurately
          </li>
          <li class="mb-2">
            <i class="bi bi-check-circle-fill text-success me-2"></i>
            Elimination of toxic or abusive domains
          </li>
          <li class="mb-2">
            <i class="bi bi-check-circle-fill text-success me-2"></i>Removal of
            spam and bot-generated email addresses
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Section 3: Usage Accordion -->
<section class="ev-usage">
  <h2 class="section-heading">
    Understanding Email Verification and its Usage
  </h2>
  <div class="ev-usage__flex">
    <div class="ev-usage__img">
      <img
        src="assets/images/email_verification.webp"
        alt="Verification Illustration"
        loading="lazy"
      />
    </div>
    <div class="ev-usage__accordion mt-5 me-3">
      <div
        class="accordion-item"
        *ngFor="let item of accordionItems; let i = index"
      >
<button class="accordion-title" (click)="toggle(i)">
  {{ item.title }}

<i
  class="bi accordion-icon"
  [ngClass]="activeIndex === i ? 'bi-chevron-up' : 'bi-chevron-down'">
</i>
</button>
        <div class="accordion-content" [class.active]="activeIndex === i">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Section 4: Expert Support -->
<section class="ev-support py-5">
  <div class="container">
    <h2 class="section-heading text-center mb-4">24/7 Expert Support</h2>
    <p class="support-desc text-center mb-5">
      Our team is available around the clock to ensure your emails are always
      delivered without issues.
    </p>

    <div class="row g-3">
      <div class="col-6 col-md-3">
        <a href="tel:+6369765570" class="card h-100 text-center btn-color p-3 support-option text-decoration-none">
          <span class="support-icon d-block mb-2"></span>
          Phone Support
        </a>
      </div>
      <div class="col-6 col-md-3">
        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@maltech.co"
           class="card h-100 text-center p-3 support-option text-decoration-none btn-color">
          <span class="support-icon d-block mb-2"></span>
          Email Support
        </a>
      </div>
      <div class="col-6 col-md-3">
        <a href="https://wa.me/6369765570" target="_blank"
           class="card h-100 text-center p-3 support-option text-decoration-none btn-color">
          <span class="support-icon d-block mb-2"></span>
          WhatsApp Support
        </a>
      </div>
      <div class="col-6 col-md-3">
        <a routerLink="/contact"  [attr.href]="'/contact'"
           class="card h-100 text-center p-3 support-option text-decoration-none btn-color">
          <span class="support-icon d-block mb-2"></span>
          24/7 Support
        </a>
      </div>
    </div>
  </div>
</section>


<!-- Section 5: Pricing -->
<section class="pricing-section text-center" id="plans">
  <h2>Only Pay For What You Use</h2>
  <p>The more you verify, the lower your cost.</p>

  <!-- Currency Switch -->
  <div class="currency-switch my-3">
    <button
      class="currency-btn outline-primary me-2"
      [class.active]="currentCurrency === 'USD'"
      (click)="setCurrency('USD')"
    >
      USD ($)
    </button>

    <button
      class="currency-btn outline-primary"
      [class.active]="currentCurrency === 'INR'"
      (click)="setCurrency('INR')"
    >
      INR (₹)
    </button>
  </div>

  <!-- Input Field -->
  <input
    type="number"
    class="form-control"
    placeholder="How many emails do you have?"
    [(ngModel)]="emailCount"
  />

  <p class="mt-2 fw-bold">Price: {{ price }}</p>
  <a routerLink="/signup"  [attr.href]="'/signup'"><button class="btn1 btn-outline" aria-label="BUY NOW Sign Up">BUY NOW</button></a>

  <!-- Rates Table -->
  <h4 class="mt-5">Pay As You Go Rates</h4>
  <table class="table table-bordered text-center">
    <thead>
      <tr>
        <th>Emails range</th>
        <th>Price per email</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of rates">
        <td>Up to {{ r.limit | number }}</td>
        <td>
          <ng-container *ngIf="currentCurrency === 'USD'">
            ${{ r.price }}
          </ng-container>
          <ng-container *ngIf="currentCurrency === 'INR'">
            ₹{{ r.price * conversionRate | number : "1.4-4" }}
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>

  <p class="enterprise">
    Enterprise Packages <br />
    Over 1,000,000 – Contact Us.
  </p>
</section>

<!-- Section 6: Why Choose MALtech -->
<section class="why-choose text-center mb-4">
  <div class="container">
    <h2 class="section-title mb-3">Why Choose MALtech</h2>
    <p class="section-subtitle mb-4">
      At MALtech, we don’t just provide email verification  we ensure
      reliability, accuracy, and efficiency at every step. Here’s why businesses
      trust us:
    </p>

    <div class="row justify-content-center g-4">
      <div
        class="col-6 col-sm-6 col-md-4 col-lg-2 d-flex justify-content-center"
        *ngFor="let feature of features"
      >
        <div class="feature-card d-flex flex-column text-center">
          <div class="icon-wrap">
            <i class="bi {{ feature.icon }}"></i>
          </div>
          <h5 class="mt-3">{{ feature.title }}</h5>
          <p>{{ feature.text }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
